import { createContext, useState, useContext, useCallback } from "react";

const FetchDataContext = createContext();

export const FetchDataProvider = ({ children }) => {
  const [triggerRefetch, setTriggerRefetch] = useState(false);
  const [globalUpdateFunction, setGlobalUpdateFunction] = useState(null);

  const setUpdateTableDataFunction = useCallback((updateFunction) => {
    setGlobalUpdateFunction(() => updateFunction);
  }, []);

  const globalUpdateTableData = useCallback(
    (newCustomer) => {
      if (globalUpdateFunction) {
        globalUpdateFunction(newCustomer);
      } else {
        console.warn(
          "Update function not set. Make sure to call setUpdateTableDataFunction in ListPage."
        );
      }
    },
    [globalUpdateFunction]
  );

  return (
    <FetchDataContext.Provider
      value={{
        triggerRefetch,
        setTriggerRefetch,
        setUpdateTableDataFunction,
        globalUpdateTableData,
      }}
    >
      {children}
    </FetchDataContext.Provider>
  );
};

export const useFetchData = () => useContext(FetchDataContext);
